var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.51.51l16.98 16.98m0-16.98L.51 17.49","stroke":"#264057","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }